/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import areaLayer from "./areas.js";
import _ from "underscore";
import util from "util/util.js";

let significantAreaInfoIfLoaded = null;

function significantAreaInfo() {
  if(!significantAreaInfo.cached) {
    significantAreaInfo.cached = birdata.significantAreas();
    significantAreaInfo.cached.then(info => significantAreaInfoIfLoaded = info);
  }
  return significantAreaInfo.cached;
}

function infoForId(id) {
  if(significantAreaInfoIfLoaded) {
    return significantAreaInfoIfLoaded[id];
  }
}

function infoPromise(id) {
  return significantAreaInfo().then(info => info[id]);
}

// A bit messy, but just a one-off
function significanceDescription(id) {
  return infoPromise(id).then(info => {
    if(info) {
      var bySignificance = {};

      info.reasons.forEach(r => {
        var reasons = bySignificance[r.significance] = bySignificance[r.significance] || [];
        reasons.push(r);
      });

      return Object.keys(bySignificance).map(significance => {
        return "<div style='font-size: 90%'><b>" + significance + " significance</b><br>" + (bySignificance[significance].map(r => {
          switch(r.criteria) {
            case "Species population threshold":
              return r.common_name + " (" + util.formatNumber(r.max_count) + ")";
            case "Total shorebird population threshold":
              return "All shorebird species (" + util.formatNumber(r.max_count) + ")";
            case "Number of shorebird species":
              return "> 15 shorebird species (" + util.formatNumber(r.max_count) + ")";
          }
        })).map(x => ' • ' + x).join("<br>") + "</div>";
      }).sort().join("");
    }
  });
}

function colorForFeature(feature) {
  var info = infoForId(feature.id);

  if(!info) {
    return "orange";
  }

  switch(info.max_significance) {
    case "National": return "blue";
    case "International": return "green";
    default: return "orange";
  }
}

function showLayer(map, options) {
  // Fire off request ASAP
  significantAreaInfo();

  options = _.defaults({
    polygonStyle: function (feature, state, defaultStyle) {
      return _.extend(defaultStyle, {
        fillColor: colorForFeature(feature)
      });
    },
    lineStyle: function(feature, state, defaultStyle) {
      return _.extend(defaultStyle, {
        strokeColor: colorForFeature(feature)
      });
    }
  }, options);

  return areaLayer.showLayer(map, options);
}

export default {
  showLayer: showLayer,
  significanceDescription
};
